import { render, staticRenderFns } from "./ViewSVG.vue?vue&type=template&id=3c3b1d88&"
import script from "./ViewSVG.vue?vue&type=script&lang=js&"
export * from "./ViewSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports